// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZTGe","expireSoon":"styles_expireSoon__2x0Jw"};